/**
 * Shared constants for the Nannyou application.
 * Single source of truth — import from here, never re-declare.
 */

// ── Absence type labels (FR) ──
export const ABSENCE_LABELS = {
  maladie_enfant: 'Maladie enfant',
  sick_child: 'Maladie enfant',
  conge_parent: 'Congé parent',
  conge_paye: 'Congé payé',
  paid_leave: 'Congé payé',
  sick_nanny: 'Maladie nounou',
  maladie_nounou: 'Maladie nounou',
  family_event: 'Événement familial',
  evenement_familial: 'Événement familial',
  unpaid_leave: 'Congé sans solde',
  conge_sans_solde: 'Congé sans solde',
  holiday: 'Jour férié',
  jour_ferie: 'Jour férié',
  formation: 'Formation',
  other: 'Autre absence',
  autre: 'Autre absence',
};

/**
 * Returns a human-readable French label for an absence type.
 * Falls back to title-casing the raw key.
 */
export function getAbsenceLabel(type) {
  if (!type) return 'Absence';
  return (
    ABSENCE_LABELS[type] ||
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

// ── Days of the week ──
export const DAYS_FR = [
  { id: 'monday', label: 'Lundi' },
  { id: 'tuesday', label: 'Mardi' },
  { id: 'wednesday', label: 'Mercredi' },
  { id: 'thursday', label: 'Jeudi' },
  { id: 'friday', label: 'Vendredi' },
  { id: 'saturday', label: 'Samedi' },
  { id: 'sunday', label: 'Dimanche' },
];

/** Short single-letter day headers (Mon–Sun). */
export const DAYS_SHORT_1 = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

/** Short 3-letter day headers. */
export const DAYS_SHORT_3 = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

// ── Months FR ──
export const MONTHS_FR = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
];

// ── API base ──
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
